// libs
import React from 'react';

import { cn } from '@lyearn/style';
// components
import { Box, Typography } from '@lyearn/ui';

// types
import { HeaderProps } from '../../../types';
// style
import { headerContainer } from '../../style';

function DialogHeader(props: { header: HeaderProps }) {
  const { header } = props;
  const { title, description, children, className, classes, variants } = header;

  return (
    <Box
      className={cn(
        'sticky top-0 z-50 bg-bg-primary px-24 pt-20 pb-20',
        headerContainer,
        className,
      )}>
      <Box className="flex">
        <Box>
          <Typography
            className={cn('flex ps-8 pe-48', classes?.title)}
            variant={variants?.title ?? 'heading-m'}>
            {title}
          </Typography>
          {description ? (
            <Typography
              className={cn('mt-8 ps-8 pe-32', { 'mb-4': !!children }, classes?.description)}
              color="text-text-secondary"
              variant={variants?.description ?? 'body-short-02'}>
              {description}
            </Typography>
          ) : null}
        </Box>
      </Box>
      {children}
    </Box>
  );
}

export default DialogHeader;
